import { Injectable } from '@angular/core';
import { Formality } from '../../../shared/enums/formalityEnum';

@Injectable({
  providedIn: 'root'
})
export class TranslationOptionsService {
  public selectedFormality: Formality = Formality.default;
  public formalityOptions = Object.values(Formality);
}
